/**
 * بازخورد کاربر.
 *
 * متن دکمه‌ها از `/api/meta` می‌آید، نه از کد: برچسب بازخورد نام صاحب منطق
 * تصمیم را در خود دارد و برای هر مشتری متفاوت است.
 *
 * ثبت بازخورد رکورد مشاوره را بازنویسی نمی‌کند؛ یک خط تازه در لاگ append-only
 * می‌نشیند و آخرین آن برنده است. پس ثبت دوباره مجاز و بی‌خطر است.
 */

import { ThumbsDown, ThumbsUp } from 'lucide-react'
import { useState } from 'react'

import { Button } from '@/components/ui/Button'
import { Card, SectionHeader } from '@/components/ui/primitives'
import { labelOf } from '@/lib/labels'
import { useMeta } from '@/lib/meta-context'

import type { UserFeedback } from '@/lib/types'

interface FeedbackBarProps {
  onSubmit: (feedback: UserFeedback, correction: string) => void
}

export const FeedbackBar = ({ onSubmit }: FeedbackBarProps) => {
  const { meta } = useMeta()
  const [correction, setCorrection] = useState('')
  const [sent, setSent] = useState<UserFeedback | null>(null)

  const send = (feedback: UserFeedback): void => {
    setSent(feedback)
    onSubmit(feedback, correction)
  }

  return (
    <Card>
      <SectionHeader
        title="بازخورد"
        caption="بازخورد شما برای سنجش کیفیت برآورد ثبت می‌شود و روی همین ماشین می‌ماند."
      />
      <div className="space-y-4 p-5">
        <div className="space-y-1.5">
          <label htmlFor="correction" className="text-xs font-semibold text-ink">
            اصلاح یا توضیح (اختیاری)
          </label>
          <textarea
            id="correction"
            value={correction}
            onChange={(event) => {
              setCorrection(event.target.value)
            }}
            rows={2}
            placeholder="اگر برآورد جایی خطا داشت، اینجا بنویسید."
            className="w-full resize-y rounded-md border border-line-strong bg-surface-raised px-3.5 py-2.5 text-sm leading-relaxed text-ink shadow-raised transition-[border-color,box-shadow] placeholder:text-ink-faint focus:border-accent focus:ring-4 focus:ring-accent/15 focus:outline-none"
          />
        </div>

        <div className="flex flex-wrap gap-2">
          <Button
            variant={sent === 'close' ? 'primary' : 'secondary'}
            icon={<ThumbsUp className="size-4" aria-hidden />}
            onClick={() => {
              send('close')
            }}
          >
            {labelOf(meta.labels, 'feedback', 'close')}
          </Button>
          <Button
            variant={sent === 'not_close' ? 'danger' : 'secondary'}
            icon={<ThumbsDown className="size-4" aria-hidden />}
            onClick={() => {
              send('not_close')
            }}
          >
            {labelOf(meta.labels, 'feedback', 'not_close')}
          </Button>
        </div>
      </div>
    </Card>
  )
}
